import React from 'react'
import classNames from 'classnames'
import { IClass } from '@/interfaces/general'
import LogoShortImage from '@/images/icons/logo/logo-short.svg?react'
import styles from './YouchatSpinner.module.scss'

type YouchatSpinnerProps = IClass

const YouchatSpinner = ({ className}: YouchatSpinnerProps) => {
  return <div className={classNames(styles.box, className)}>
    <LogoShortImage/>
  </div>
}

export default YouchatSpinner
